module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_7.4ee96207.png";